import { Breadcrumbs as MUIBreadcrumbs, Typography, styled } from '@mui/material';

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'sticky',
})<{ sticky?: boolean }>(({ theme, sticky }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px 20px',
  marginBottom: '16px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.background.paper,
  ...(sticky
    ? {
        position: 'sticky',
        top: 0,
        zIndex: 3,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
      }
    : {
        marginTop: '16px',
      }),
}));

export const BreadcrumbsRow = styled('div')(({ theme }) => ({
  '& .MuiBreadcrumbs-root': {
    height: '28px',
    color: theme.palette.text.secondary,
    fontSize: '13px',
    '& a, & .MuiTypography-root': {
      fontSize: '13px',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
}));

export const HeaderRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
}));

export const Title = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 600,
}));

export const StyledBreadcrumbs = styled(MUIBreadcrumbs)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}));
